import { Box, Chip } from '@mui/material';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { useRefinementList } from 'react-instantsearch';
import { useTranslation } from 'react-i18next';
import useNormalizedCurrentRefinements from '../../../hooks/useNormalizedCurrentRefinements';
import { CompanyCategoryOptions } from './CompanyCategoryFilter';

export default function CompanyCategoryFilterTags(): React.JSX.Element {
  const { t } = useTranslation(['social-proof']);
  const { refine } = useRefinementList({ attribute: 'is_wholesaler' });
  const currentRefinements = useNormalizedCurrentRefinements('is_wholesaler');

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {currentRefinements.map((refinement) => {
        const option = CompanyCategoryOptions.find(({ refinementValue }) => refinementValue === refinement)!;

        return (
          <Chip
            key={refinement}
            variant="filter"
            icon={<StorefrontOutlinedIcon />}
            label={t(`social-proof:${option.category.toLowerCase()}.title`)}
            onDelete={() => refine(option.refinementValue)}
          />
        );
      })}
    </Box>
  );
}
